import { currencyFormat } from 'common/helpers/numberHelper';

const Duties = (props) => {
  const { duties, settings } = props;
  if (!duties) {
    return null;
  }
  const dutyUnpaid = duties.filter(
    (duty) => duty.isUnpaidDutyEstimate === true
  );
  return (
    <>
      {dutyUnpaid.map((duty) => (
        <div key={duty.id}>
          <div>{duty.title} Estimate:</div>
          <div>{currencyFormat(duty.price, settings)}</div>
        </div>
      ))}
    </>
  );
};

export default Duties;
